/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * Used to provide consistency and keep DRY for our toggle classes.
 */
export default {
    active: 'is-active',
    added: 'is-added',
    adding: 'is-adding',
    collapsed: 'is-collapsed',
    currentCarSet: 'current-car-set',
    currentCarView: 'current-car-view',
    currentCarVinSet: 'current-car-vin-set',
    disabled: 'is-disabled',
    disableOverlay: 'disable-overlay',
    erroneous: 'is-erroneous',
    focused: 'is-focused',
    hidden: 'is-hidden',
    loaded: 'is-loaded',
    loading: 'is-loading',
    locked: 'is-locked',
    navCollapsed: 'is-nav-collapsed',
    overflow: 'no-overflow',
    removing: 'is-removing',
    retrieving: 'is-retrieving',
    searchHide: 'hide-search-dropdown',
    searchLocked: 'is-search-locked',
    selected: 'is-selected',
    settingCurrentCar: 'setting-current-car',
    sticky: 'is-sticky',
    successful: 'is-successful',
    tabbable: 'is-tabbable',
    transitioning: 'is-transitioning',
    valid: 'is-valid',
    visible: 'is-visible',
    zoomed: 'is-zoomed',
    compatible: 'is-compatible',
    incompatible: 'is-incompatible'
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/cssClasses.js